'use client';

import { useMedia } from 'react-use';

export default function useWindowsSize() {
  const xs = useMedia('(min-width: 1px) and (max-width: 441px)', false);
  const sm = useMedia('(min-width: 441px)', false);
  const md = useMedia('(min-width: 734px)', false);
  const lg = useMedia('(min-width: 735px)', false);
  const xl = useMedia('(min-width: 840px)', false);
  const xxl = useMedia('(min-width: 1068px)', false);
  const xxxl = useMedia('(min-width: 1440px)', false);
  const xxxxl = useMedia('(min-width: 1920px)', false);

  const dd2XL = useMedia('(max-width: 1439px)', false)
  const ddXL = useMedia('(max-width: 1023px)', false)
  const ddLG = useMedia('(max-width: 767px)', false)
  const ddMD = useMedia('(max-width: 479px)', false)

  const dd22XL = useMedia('(max-width: 991px)', false)

  return {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    xxxl,
    xxxxl,

    ddXL,
    dd2XL,
    ddLG,
    ddMD,

    dd22XL
  };
}
